import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React, { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { translationHookOptions } from "../../app/localization/localization";
import { ITenant } from "../../app/models/tenant";
import { RootStoreContext } from "../../app/stores/rootStore";
import SidebarGenericButton from "../buttons/SidebarGenericButton";

interface IParams {
  tenant: ITenant;
  currentUrl?: string;
}

const SidebarLinksComponent: React.FC<IParams> = ({ tenant, currentUrl }) => {
  const rootStore = useContext(RootStoreContext);
  const { loadLinks, loadOfflineLinks, playerLinks } = rootStore.playerStore;
  const { isOfflineModeEnabled } = rootStore.commonStore;
  const { isMobileMediaQuery,setIsSidebarModalOpen } = rootStore.responsiveStore;
  const [t] = useTranslation(["translation"], translationHookOptions);

  useEffect(() => {
    if (isOfflineModeEnabled) loadOfflineLinks();
    else loadLinks().then().catch();
  }, [loadLinks, loadOfflineLinks, isOfflineModeEnabled]);

  const renderSwitch = (param: string) => {
    switch (param) {
      case "archives":
        return "fas fa-archive text";
      case "meetings":
        return "fas fa-columns";
      case "board":
        return "fas fa-chalkboard";
      case "search":
        return "fas fa-search";
      default:
        return "fas fa-columns";
    }
  };

  return (
    <>
      {playerLinks.map((pl, index) => (
        <div key={index} className={classNames(isMobileMediaQuery? "col-6 mobileSidebarButtonContainer" : "", "pt-0 pb-0")}>
          <Link to={`${tenant.path}/${pl.link}`} className="pb-0">
            <SidebarGenericButton
              icon={renderSwitch(pl.link)}
              label={t(pl.label)}
              isActive={currentUrl === `${tenant.path}/${pl.link}`}
              onClick={()=> isMobileMediaQuery && setIsSidebarModalOpen(false)}
            />
          </Link>
        </div>
      ))}
    </>
  );
};

export default observer(SidebarLinksComponent);
